import humanIcon from '../../assets/images/human_account.svg';
import instantIcon from '../../assets/images/instant_order.svg';
import endToEndIcon from '../../assets/images/end_to_end.svg';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: humanIcon,
    title: 'Human Account Managers',
    description:
      "You'll never talk to a bot. Our real logistics experts help design the right strategy for your business goals.",
  },
  {
    icon: instantIcon,
    title: 'Instant Order Dispatch',
    description:
      'No wait time, no guesswork. Orders are assigned in real-time with full delivery tracking at every step.',
  },
  {
    icon: endToEndIcon,
    title: 'End-End Tracking',
    description:
      'Track every order from pickup to drop-off. Stay informed with delivery timelines, and visual proof.',
  },
];

function Features() {
  return (
    <section className="bg-white py-16 px-4">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {features.map((feature) => (
          <div key={feature.title} className="bg-gray-100 p-8 rounded-lg flex flex-col gap-4 hover:shadow-md transition-shadow">
            <img src={feature.icon} alt={feature.title} className="w-20 h-20" />
            <h3 className="text-3xl font-semibold text-[#F55109] uppercase" style={{ fontFamily: 'Antonio, sans-serif' }}>
              {feature.title}
            </h3>
            <p className="text-gray-700 text-base leading-relaxed">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Features;
